import { call, select } from 'redux-saga/effects';
import { downloadFile } from 'utils/http/downloadFile';
import { AxiosResponse } from 'axios';
import { selectRoomId } from 'features/room/roomSlice';
import { exportSingleQuizService } from 'features/quizzes/services';
import { exportSingleQuizRequested } from 'features/quizzes/actions';
import * as Sentry from '@sentry/react';

export function* exportSingleQuizSaga(action: ReturnType<typeof exportSingleQuizRequested>) {
  try {
    const roomId: string = yield select(selectRoomId);

    const response: AxiosResponse<Blob> = yield call(
      exportSingleQuizService,
      roomId,
      action.payload
    );
    const contentDisposition = response.headers['content-disposition'];

    yield call(downloadFile, response.data, contentDisposition);
  } catch (error) {
    Sentry.captureException(error);
  }
}
